<template>
    <div :class="[ 'modal-content', needLoader && isLoading && 'modal-blur']">
      <preloader class="modal-preloader" :showPreloader="needLoader && isLoading"/>
      <div class="modal-header" v-if="showHeader">
        <h1 v-if="showTitle" class="h2-type-2">{{title}}</h1>
        <span class="btn-close" @click="closeModal"></span>
      </div>
      <div class="modal-body" v-if="this.$slots.body">
        <slot name="body"></slot>
      </div>
      <div class="modal-footer" v-if="showFooter" :style="{justifyContent: btnStyles[btnPosition]}">
        <button
            v-if="!this.$slots.footer"
            type="button"
            :class="applyBtn.typeClass"
            @click="apply"
            :disabled="applyBtn.disabled"
        >
          {{applyBtn.text}}
        </button>
        <button
            v-if="!this.$slots.footer"
            type="button"
            @click="closeModal"
            :class="cancelBtn.typeClass"
        >
          {{cancelBtn.text}}
        </button>
        <slot name="footer"></slot>
      </div>
    </div>
</template>
<script>
import Vue from "vue";
import Preloader from "@/components/Preloader/Preloader.vue";

const styles = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center'
}
export default Vue.extend({
  components: {Preloader},
  computed: {
    showTitle() {
      return this.$props.title?.length
    }
  },
  data() {
    return {
      btnStyles: styles,
      isLoading: false
    }
  },
  props: {
    name: String,
    title: {type: String},
    needLoader: {type: Boolean, default: true},
    awaitApply: {type: Boolean, default: true},
    showFooter: {type: Boolean, default: true},
    showHeader: {type: Boolean, default: true},
    customClass: {type: String, default: ''},
    btnPosition: {type: String, default: 'right'}, // left, right, center
    applyBtn: {
      type: Object,
      default: () => ({
        typeClass: 'green-btn',
        text: 'Confirm',
        disabled: false,
      })
    },
    cancelBtn: {
      type: Object,
      default: () => ({
        typeClass: 'black-border-btn',
        text: 'Cancel'
      })
    },
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.$modal.hide(this.$props.name)
    },
    beforeClose({params}) {
      if (params?.applied) return
      this.$emit('before-cancel-cb')
    },
    async apply() {
      if (this.$props.needLoader) this.isLoading = true
      this.$emit('apply-cb', (isError = false) => {
        if (!isError) this.$modal.hide(this.$props.name, {applied: true})
        this.isLoading = false
      })
    },
  }
})
</script>
<style lang="scss" src="./ModalStyles.scss"></style>
